<template>
    <div class="mt-5">
        <div class="flex">
            <div class="mr-3">
                <input
                    type="radio"
                    v-model="order"
                    id="alphabetical"
                    name="order"
                    value="alphabetical"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                />
                <label for="alphabetical">{{ $t('messages.alphabetical') }}</label>
            </div>

            <div>
                <input
                    type="radio"
                    v-model="order"
                    id="value"
                    name="order"
                    value="value"
                    class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                />
                <label for="value">{{ nonAlphabeticalOrderText }}</label>
            </div>
        </div>
        <div>
            <apexcharts height="350" type="bar" :options="chartOptions" :series="series" />
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
    name: 'GradesBarGraphSortable',
    components: {
        apexcharts: VueApexCharts,
    },
    props: {
        inputSeries: {
            type: Object,
            required: true,
        },
        inputOptions: {
            type: Object,
            required: true,
        },
        nonAlphabeticalOrder: {
            type: String,
            required: false,
        },
    },
    data: function () {
        return {
            order: 'alphabetical',
            chartOptions: this.inputOptions,
            series: [this.inputSeries],
            nonAlphabeticalOrderText: this.nonAlphabeticalOrder
                ? this.nonAlphabeticalOrder
                : this.$t('messages.order_by_grade'),
        };
    },
    watch: {
        order: function (newOrder) {
            let data = this.series[0].data;
            if (newOrder === 'value') {
                data.sort((a, b) => a.y - b.y);
            } else if (newOrder === 'alphabetical') {
                data.sort((a, b) => (a.sort < b.sort ? -1 : 1));
            }
            this.series = [
                {
                    name: 'series-1',
                    data,
                },
            ];
        },
    },
};
</script>
